import React from 'react';
import styled from 'styled-components';
import { email } from '@config';
import { useReveal } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: var(--space-3);
    color: var(--text-muted);
    font-family: var(--font-sans);
    font-size: var(--fz-lg);
    font-weight: 400;
  }

  /* The section number belongs on the real title, not on the small eyebrow
     above it — otherwise "05." labels a line of 16px text while the actual
     heading sits underneath unnumbered. Centred, and without the trailing
     rule the other sections use, because this section is centre-aligned. */
  .title {
    justify-content: center;
    margin-bottom: var(--space-4);
    white-space: normal;

    &:after {
      display: none;
    }
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useReveal();

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <p className="overline">What’s Next?</p>

      <h2 className="numbered-heading title">Get In Touch</h2>

      <p>
        Whether you have a question or just want to say hi, I’ll try my best to get back to you!
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        Say Hello
      </a>
    </StyledContactSection>
  );
};

export default Contact;
